import { getChain, sendSolanaTransaction, type SolanaProvider } from '@particle-network/connector-core';
import type { SolanaWallet } from '@particle-network/wallet';
import type { Transaction, VersionedTransaction } from '@solana/web3.js';

export const createSolanaWallet = (
  provider: SolanaProvider,
  chainId: number
): SolanaWallet & { provider: SolanaProvider } => {
  return {
    provider,
    publicKey: provider.publicKey,
    chainId: chainId || 101,
    on(event, listener) {
      provider.on(event, listener);
      return this;
    },
    removeListener(event, listener) {
      provider.removeListener(event, listener);
      return this;
    },
    async connect() {
      await provider.connect();
    },
    async signTransaction<T extends Transaction | VersionedTransaction>(transaction: T): Promise<T> {
      return await provider.signTransaction(transaction);
    },
    async signAllTransactions<T extends Transaction | VersionedTransaction>(transactions: T[]): Promise<T[]> {
      return await provider.signAllTransactions(transactions);
    },
    async signAndSendTransaction<T extends Transaction | VersionedTransaction>(
      transaction: T
    ): Promise<{
      signature: string;
    }> {
      const chain = getChain(chainId);
      const module = await import('@solana/web3.js');
      const { Connection } = module.default || module;
      const connection = new Connection(chain.rpcUrls.default.http[0]!);
      return await sendSolanaTransaction(provider, transaction, connection);
    },
    async signMessage(message: Uint8Array): Promise<{
      signature: Uint8Array;
    }> {
      return await provider.signMessage(message);
    },
    async switchChain(chainId: number) {
      throw new Error('Wallet not support switch chain.');
    },
  };
};
